import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Formik } from 'formik';
import { Autocomplete, Avatar, createTheme, Divider, FormHelperText, Grid2, IconButton, List, ListItem, ListItemAvatar, ListItemText, TextField, ThemeProvider, useTheme } from '@mui/material';
import * as Yup from 'yup';
import { useState } from 'react';
import DragAndDropUpload from 'components/FileUploader/DragAndDropUpload';
import { useNavigate, useParams } from 'react-router-dom';
import { IoMdClose } from 'react-icons/io';
import { FaRegFileLines } from 'react-icons/fa6';
import { useUpdateReSubmitDocMutation } from 'store/slices/apis/documentsSlice';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import moment from 'moment';
import { useGetAllWorkflowQuery } from 'store/slices/apis/workflowSlice';
import { ReactComponent as CalendarIcon } from "assets/PwC_Funct_Icons_Calendar_Outline_Black_RGB.svg"

export default function EditDocument(props) {
    const { open, cancelIssue, openNotification, rowData } = props;

    const newtheme = useTheme();
    const { projectId } = useParams();
    // const [file, setFile] = useState(null);
    const [dense, setDense] = useState(false);
    const [secondary, setSecondary] = useState(false);

    const navigate = useNavigate();

    const [reSubmitDocumentFun, reSubmitDocumentRes] = useUpdateReSubmitDocMutation();
    const workflowList = useGetAllWorkflowQuery({ projectId, pageNumber: 1, pageSize: 100, entityName: 'Document' })

    const [formData, setFormData] = useState({
        docName: rowData?.documentName,
        file: '',
        plan_date: rowData?.planDate,
        id: rowData?.id,
        WorkflowApprovalId: rowData?.workflowApprovalId,
        projectId
    })

    const CustomCalendarIcon = (props) => (
        <CalendarIcon {...props} style={{ width: 26, height: 26, fill:"#696969 ", stroke:"#696969", strokeWidth:4 }} />
      );

    const theme = createTheme({
        components: {

            MuiTextField: {
                styleOverrides: {
                    root: {
                        border: '2px solid #e6e6e6', '& .MuiFilledInput-input': {
                            backgroundColor: '#fff',
                            color: '#252525',
                            fontSize: '16px'
                        },
                        '& .MuiFilledInput-root::before': {
                            borderBottom: 'none'
                        },
                        '& .MuiFilledInput-root::after': {
                            borderBottom: `2px solid ${newtheme?.customSettings?.themeColor}`
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                            color: '#696969',
                            fontSize: '14px'
                        },
                        '& .MuiFormLabel-root': {
                            fontSize: '15px'
                        },
                        '& .MuiFilledInput-root.Mui-disabled:before': {
                            borderBottom: 'none'
                        },
                        '& .MuiFilledInput-root': {
                            backgroundColor: '#fff'
                        },
                        '& .MuiFilledInput-input': {
                            backgroundColor: 'none',
                            fontSize: '14px'
                        }
                    },
                },
            }
        },
    });

    const validationSchema = Yup.object({
        docName: Yup.string().required("Document name field is required."),
        // status: Yup.string().required("Status field is required."),
        file: Yup.mixed().required("Document field is required."),
        plan_date: Yup.date()
            .required("Plan Date field is required")
            .nullable()
            .typeError("Plan Date must be a valid date"),
        // WorkflowApprovalId: Yup.string().required("Workflow field is required."),
    });

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        // console.log(dayjs(values?.plan_date)?.format('YYYY-MM-DD'));
        const fields = new FormData();
        Object.entries(values).forEach(([key, value]) => {
            if (key == 'plan_date') {
                fields.append(key, dayjs(values?.plan_date)?.format('YYYY-MM-DD'));
            } else {
                fields.append(key, value);
            }
        });

        reSubmitDocumentFun({ body: fields, id: rowData?.id })
    };

    React.useEffect(() => {
        if (reSubmitDocumentRes?.isSuccess) {
            if (reSubmitDocumentRes?.data?.status == 'success') {
                openNotification(reSubmitDocumentRes?.data?.message, 'success')
            } else {
                openNotification(reSubmitDocumentRes?.data?.message, 'error')
            }
            cancelIssue();
            // navigate(`/projects/${projectId}/documents/pending-approval-documents/${activityId}`);
        }
    }, [reSubmitDocumentRes?.isSuccess]);

    React.useEffect(() => {
        if (reSubmitDocumentRes?.isError) {
            openNotification('Something went wrong!', 'error')
        }
    }, [reSubmitDocumentRes?.isError]);
    return (
        <React.Fragment>
            <Dialog
                fullWidth={true}
                maxWidth={'sm'}
                open={open}
                sx={{
                    '& .MuiDialog-paper': {
                        overflowY: 'inherit'
                    }
                }}
            >
                <DialogTitle sx={{ fontSize: '20px', color: '#696969' }}>Resubmit Document</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={cancelIssue}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <IoMdClose style={{ fontSize: '20px' }} />
                </IconButton>
                <Divider sx={{ w: 1 }} />
                <DialogContent>
                    <ThemeProvider theme={theme}>
                        <Box sx={{ mt: 1 }}>
                            <Formik
                                initialValues={formData}
                                validationSchema={validationSchema}
                                onSubmit={handleSubmit}
                                enableReinitialize
                            >
                                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue, setTouched }) => (
                                    <form onSubmit={handleSubmit}>

                                        <Grid2 container spacing={2}>
                                            {/* <Grid2 size={12}>
                                                <Autocomplete
                                                    options={workflowList?.data?.data || []}
                                                    getOptionLabel={(option) => option?.workflowName}
                                                    value={workflowList?.data?.data?.find((option) => option?.id === values?.WorkflowApprovalId) || null}
                                                    onChange={(_, newValue) => setFieldValue("WorkflowApprovalId", newValue ? newValue?.id : "")}
                                                    onBlur={() => setTouched({ ...touched, WorkflowApprovalId: true })}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Select Workflow"
                                                            placeholder='Select Workflow'
                                                            name="WorkflowApprovalId"
                                                            slotProps={{ inputLabel: { shrink: true } }}
                                                            variant="filled"
                                                        />
                                                    )}
                                                    ListboxProps={{
                                                        sx: { fontSize: "13px" },
                                                    }}
                                                />
                                                {touched?.WorkflowApprovalId && errors?.WorkflowApprovalId &&
                                                    <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.WorkflowApprovalId}`}</FormHelperText>
                                                }

                                            </Grid2> */}
                                            <Grid2 size={12}>
                                                <TextField
                                                    id="outlined-multiline-static2"
                                                    label="Document Name"
                                                    name="docName"
                                                    placeholder='Enter Document Name'
                                                    fullWidth
                                                    value={values?.docName}
                                                    onChange={handleChange}
                                                    onBlur={() => setTouched({ ...touched, docName: true })}
                                                    slotProps={{ inputLabel: { shrink: true } }}
                                                    variant="filled"
                                                />
                                                {touched?.docName && errors?.docName &&
                                                    <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.docName}`}</FormHelperText>
                                                }
                                            </Grid2>
                                            <Grid2 size={12}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        label="Plan date of submission"
                                                        value={
                                                            values?.plan_date ? dayjs(values.plan_date) : null
                                                        }
                                                        format="DD-MM-YYYY"
                                                        onChange={(newValue) => {
                                                            handleChange({
                                                                target: {
                                                                    name: "plan_date",
                                                                    value: newValue ? newValue : "",
                                                                },
                                                            });
                                                        }}
                                                        slots={{
                              openPickerIcon: CustomCalendarIcon,
                            }}
                                                        onBlur={() =>
                                                            setTouched({ ...touched, plan_date: true })
                                                        }
                                                        slotProps={{
                                                            textField: {
                                                                fullWidth: true,
                                                                variant: "filled",
                                                                InputLabelProps: {
                                                                    shrink: true,
                                                                    style: { fontWeight: 400 },
                                                                },
                                                                inputProps: {
                                                                    style: { height: "20px" },
                                                                },
                                                                placeholder: "DD/MM/YYYY",
                                                                sx: {
                                                                    input: {
                                                                        "&::placeholder": {
                                                                            fontSize: 14,
                                                                            fontWeight: 400,
                                                                        },
                                                                    },
                                                                    "& .MuiFormLabel-asterisk": {
                                                                        color: "red",
                                                                        fontSize: 20,
                                                                    },
                                                                },
                                                                onKeyDown: (e) => e.preventDefault(),
                                                            },
                                                        }}
                                                    />
                                                    {touched?.plan_date && errors?.plan_date && (
                                                        <FormHelperText
                                                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                                                        >{`${errors?.plan_date}`}</FormHelperText>
                                                    )}
                                                </LocalizationProvider>
                                            </Grid2>

                                            <Grid2 size={12}>
                                                <DragAndDropUpload onDrop={(acceptedFiles, rejectedFiles) => {
                                                    if (rejectedFiles.length > 0) {
                                                        openNotification("File type must be image/*");
                                                        return;
                                                    }
                                                    setFieldValue("file", acceptedFiles[0])

                                                }} />
                                                {touched?.file && errors?.file &&
                                                    <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.file}`}</FormHelperText>
                                                }
                                            </Grid2>
                                            <Grid2 size={12}>
                                                {values?.file != '' &&
                                                    <List dense={dense}>
                                                        <ListItem
                                                            sx={{
                                                                padding: 0,
                                                                m: 0
                                                            }}
                                                        >
                                                            <ListItemAvatar>
                                                                <Avatar sx={{ background: 'none' }}>
                                                                    <FaRegFileLines fontSize="inherit" style={{ color: '#474747' }} />
                                                                </Avatar>
                                                            </ListItemAvatar>
                                                            <ListItemText
                                                                primary={`${values?.file?.name}`}
                                                                secondary={secondary ? 'Secondary text' : null}
                                                            />
                                                        </ListItem>
                                                    </List>
                                                }
                                            </Grid2>
                                            <Grid2 size={12}>
                                                <Button
                                                    type='submit'
                                                    loading={reSubmitDocumentRes?.isLoading}
                                                    variant="contained"
                                                    sx={{
                                                        backgroundColor: `${newtheme?.customSettings?.themeColor}`,
                                                        color: '#FFF', padding: '7px 20px',
                                                        fontWeight: '500', textTransform: 'none',
                                                        fontSize: '16px', float: 'right'
                                                    }}>
                                                    Save
                                                </Button>
                                            </Grid2>
                                        </Grid2>
                                    </form>
                                )}
                            </Formik>
                        </Box>
                    </ThemeProvider>
                </DialogContent>
            </Dialog>
        </React.Fragment >
    );
}